/* SKYMILK V2 interactions — 2026-10-27. 페이지에 해당 요소가 있을 때만 각 기능이 켜짐 */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];


  // 헤더: 히어로가 있으면 영상 아래로 내려갈 때 유리 바탕, 없으면 항상 유리 바탕
  const header = $('#v2Header');
  const hero = $('.v2-hero');
  const heroMedia = $('#v2HeroMedia');
  const heroCopy = $('#v2HeroCopy');
  const st = $('#v2Statement');
  let statementWords = [];
  if (st) {
    st.innerHTML = st.textContent.trim().split(/\s+/).map(w => `<span class="w">${w}</span>`).join(' ');
    statementWords = $$('.w', st);
  }
  // 스크롤 처리는 프레임당 한 번만(떨림 방지). 농장 사진 패럴랙스는 제거(10/27, 사용자 요청)
  const onScroll = () => {
    const y = window.scrollY;
    if (header) header.classList.toggle('is-solid', !hero || y > hero.offsetHeight - 80);
    if (hero && heroMedia && heroCopy && y < hero.offsetHeight) {
      heroMedia.style.transform = `translate3d(0,${Math.round(y * 0.18)}px,0)`;
      heroCopy.style.transform = `translate3d(0,${Math.round(y * -0.12)}px,0)`;
      heroCopy.style.opacity = String(Math.max(0, 1 - y / (hero.offsetHeight * 0.6)));
    }
    if (statementWords.length) {
      const sr = st.getBoundingClientRect();
      if (sr.bottom > 0 && sr.top < innerHeight) {
        const line = innerHeight * 0.72;
        statementWords.forEach(w => w.classList.toggle('on', w.getBoundingClientRect().top < line));
      }
    }
  };
  let ticking = false;
  const queueScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; onScroll(); }); };
  onScroll(); window.addEventListener('scroll', queueScroll, { passive: true }); window.addEventListener('resize', queueScroll);
  // 영상 위에서도 헤더에 마우스가 올라오면 유리 바탕
  if (header) {
    header.addEventListener('pointerenter', () => header.classList.add('is-hover'));
    header.addEventListener('pointerleave', () => header.classList.remove('is-hover'));
  }

  // 스크롤 등장
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (!e.isIntersecting) return; e.target.classList.add('is-in'); io.unobserve(e.target); });
  }, { threshold: .2 });
  $$('[data-v2-reveal]').forEach(el => io.observe(el));

  // 모바일 메뉴
  const drawer = $('#v2Drawer');
  if (drawer) {
    // 11/3 접근성: 열면 닫기 버튼으로 포커스, Esc로 닫기, Tab은 서랍 안에서만 순환, 닫으면 열기 버튼으로 복귀, 뒤 페이지 스크롤 잠금
    const openBtn = $('#v2MenuOpen'), closeBtn = $('#v2MenuClose');
    const setOpen = (on) => {
      drawer.hidden = !on;
      openBtn && openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.body.style.overflow = on ? 'hidden' : '';
      if (on) (closeBtn || drawer).focus();
      else if (openBtn && (drawer.contains(document.activeElement) || document.activeElement === document.body)) openBtn.focus();
    };
    openBtn?.addEventListener('click', () => setOpen(true));
    closeBtn?.addEventListener('click', () => setOpen(false));
    $$('a', drawer).forEach(a => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', e => {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key !== 'Tab') return;
      const f = $$('button, a[href]', drawer); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // 히어로 영상 자동재생 재시도
  const v = $('#v2HeroVideo');
  if (v) {
    const evs = ['pointerdown', 'touchstart', 'scroll', 'keydown', 'wheel'];
    const stop = () => evs.forEach(n => window.removeEventListener(n, tryPlay));
    const tryPlay = () => { if (!v.paused) { stop(); return; } v.play().then(stop).catch(() => {}); };
    tryPlay();
    evs.forEach(n => window.addEventListener(n, tryPlay, { passive: true }));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tryPlay(); });
    v.addEventListener('canplay', tryPlay, { once: true });
  }

  // 제품 라인: 무한 회전 캐러셀
  const row = $('#v2LineRow');
  if (row && row.children.length > 1) {
    const originals = [...row.children];
    const N = originals.length, CL = Math.min(4, N);
    const clone = t => { const c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; return c; };
    originals.slice(-CL).reverse().forEach(t => row.insertBefore(clone(t), row.firstChild));
    originals.slice(0, CL).forEach(t => row.appendChild(clone(t)));
    let idx = CL, timer, busy = false;
    const perView = () => Math.ceil(parseFloat(getComputedStyle(row).getPropertyValue('--n')) || 4);
    const stepPx = () => row.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(row).gap || 0);
    const setX = anim => {
      row.classList.toggle('no-anim', !anim);
      row.style.transform = `translateX(${-idx * stepPx()}px)`;
      if (!anim) { row.getBoundingClientRect(); row.classList.remove('no-anim'); }
      navTop();
    };
    // 화살표 높이 = 타일 사진의 세로 가운데 (.v2-wrap 기준)
    const wrapEl = row.closest('.v2-wrap');
    const navTop = () => {
      const img = row.querySelector('.v2-tile__img');
      if (!img || !wrapEl) return;
      const r = img.getBoundingClientRect(), w = wrapEl.getBoundingClientRect();
      wrapEl.style.setProperty('--v2-nav-top', Math.round(r.top - w.top + r.height / 2) + 'px');
    };
    window.addEventListener('load', navTop);
    const settle = () => { busy = false; if (idx >= N + CL) { idx -= N; setX(false); } else if (idx < CL) { idx += N; setX(false); } };
    const go = d => {
      if (busy) return; busy = true;
      idx += d; setX(true);
      const enter = row.children[d > 0 ? idx + perView() - 1 : idx];
      if (enter) { enter.classList.remove('is-new'); void enter.offsetWidth; enter.classList.add('is-new'); }
      setTimeout(settle, 1150);
    };
    const restart = () => { clearInterval(timer); timer = setInterval(() => go(1), 3500); };
    row.addEventListener('pointerover', e => { if (e.target.closest('.v2-tile')) clearInterval(timer); });
    row.addEventListener('pointerout', e => { if (e.target.closest('.v2-tile') && !(e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.v2-tile'))) restart(); });
    const nav = $('.v2-line__nav');
    if (nav) { nav.addEventListener('pointerenter', () => clearInterval(timer)); nav.addEventListener('pointerleave', restart); }
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearInterval(timer); else restart(); });
    $('#v2LineBack')?.addEventListener('click', () => go(-1));
    $('#v2LineNext')?.addEventListener('click', () => go(1));
    window.addEventListener('resize', () => setX(false));
    setX(false); restart();

    // 드래그/스와이프로 넘기기 (PC 마우스 + 휴대폰 손가락). 세로 스크롤은 그대로 (10/29)
    const vpEl = row.closest('.v2-line__viewport') || row;
    let drag = null;
    vpEl.addEventListener('pointerdown', e => {
      if (busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
      drag = { x: e.clientX, y: e.clientY, dx: 0, moved: false };
      clearInterval(timer);
    });
    vpEl.addEventListener('pointermove', e => {
      if (!drag) return;
      const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }   // 세로로 움직이면 페이지 스크롤에 양보
        drag.moved = true; row.classList.add('no-anim');
        try { vpEl.setPointerCapture(e.pointerId); } catch (_) {}
      }
      drag.dx = dx;
      row.style.transform = `translateX(${-idx * stepPx() + dx}px)`;
      e.preventDefault();
    });
    const endDrag = () => {
      if (!drag) return;
      const d = drag; drag = null;
      row.classList.remove('no-anim');
      if (d.moved) {
        if (Math.abs(d.dx) > 40) go(d.dx < 0 ? 1 : -1); else setX(true);
        row.dataset.dragged = '1'; setTimeout(() => { delete row.dataset.dragged; }, 80);
      }
      restart();
    };
    vpEl.addEventListener('pointerup', endDrag);
    vpEl.addEventListener('pointercancel', endDrag);
    row.addEventListener('click', e => { if (row.dataset.dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  // 제품 타일 제형컷(webp): 마우스 있는 기기에서만. 타일이 화면 근처에 오면 미리 받아 두고(늦게 뜨는 것 방지),
  // 그 전에 마우스가 닿으면 그때 바로 받음. ※ 반드시 위 캐러셀의 복제 타일이 만들어진 뒤에 실행(복제본도 포함) (10/29)
  if (window.matchMedia('(hover:hover)').matches) {
    const hovers = $$('.v2-tile__hover[data-src]');
    const load = img => { if (!img.getAttribute('src')) { img.src = img.dataset.src; if (img.tagName === 'VIDEO') { img.load(); } else if (img.decode) img.decode().catch(() => {}); } };
    hovers.forEach(img => {
      const tile = img.closest('.v2-tile') || img;
      tile.addEventListener('pointerenter', () => load(img), { once: true });
      tile.addEventListener('focus', () => load(img), { once: true });
      if (img.tagName === 'VIDEO') { // 11/3 제형컷 mp4: 마우스 올리면 재생, 내리면 멈춤
        tile.addEventListener('pointerenter', () => { load(img); img.play().catch(() => {}); });
        tile.addEventListener('pointerleave', () => { img.pause(); });
      }
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (!e.isIntersecting) return;
          const inRow = e.target.closest('#v2LineRow');
          // 홈 컬렉션 줄은 가려진 칸까지 회전해 들어오므로 한 칸이라도 보이면 줄 전체를 미리 받음
          (inRow ? $$('.v2-tile__hover[data-src]', inRow) : [e.target.querySelector('.v2-tile__hover[data-src]') || e.target]).forEach(load);
          io.unobserve(e.target);
        });
      }, { rootMargin: '600px 600px' });
      hovers.forEach(img => io.observe(img.closest('.v2-tile') || img));
    } else {
      window.addEventListener('load', () => hovers.forEach(load));
    }
  }

  // 베스트셀러 슬라이드
  const slides = $$('.v2-best__slide');
  if (slides.length) {
    const items = $$('.v2-best__item');
    const dots = $('#v2BestDots');
    let cur = 0, timer;
    const go = i => { cur = (i + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-on', k === cur)); items.forEach((s, k) => s.classList.toggle('is-on', k === cur)); dotEls.forEach((d, k) => d.classList.toggle('is-on', k === cur)); };
    const restart = () => { clearInterval(timer); timer = setInterval(() => go(cur + 1), 5000); };
    slides.forEach((_, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Best 0' + (i + 1)); b.addEventListener('click', () => { go(i); restart(); }); dots.appendChild(b); });
    const dotEls = [...dots.children];
    go(0); restart();
    $('#v2BestNext')?.addEventListener('click', () => { go(cur + 1); restart(); });
    $$('.v2-best .v2-textlink, #v2BestDots, #v2BestNext').forEach(el => { el.addEventListener('pointerenter', () => clearInterval(timer)); el.addEventListener('pointerleave', restart); });
  }

  // 제품 상세 갤러리
  const gMain = $('#v2GalleryMain');
  if (gMain) {
    $$('.v2-gallery__thumbs button').forEach(b => b.addEventListener('click', () => {
      $$('.v2-gallery__thumbs button').forEach(x => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      gMain.src = b.dataset.src; gMain.alt = b.dataset.alt || '';
    }));
  }

  // 제품 상세 임상 수치(11/2): 화면에 들어오면 숫자가 0부터 올라가고 막대가 참
  const stats = $$('.v2-stat, .v2-dk__stats');
  if (stats.length) {
    const ease = t => 1 - Math.pow(1 - t, 3);
    // data-count는 '58.08%', '−3.88°C', '+51.57%' 같은 표시 문자열 그대로: 앞 부호·뒤 단위는 두고 숫자만 셈
    const count = el => {
      const target = el.dataset.count || '0';
      const m = target.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)(.*)$/);
      if (!m) { el.textContent = target; return; }
      const [, pre, numStr, post] = m;
      const dec = (numStr.split('.')[1] || '').length;
      const end = parseFloat(numStr) || 0;
      const t0 = performance.now(), dur = 1300;
      const step = now => {
        const p = Math.min(1, (now - t0) / dur);
        el.textContent = pre + (end * ease(p)).toFixed(dec) + post;
        if (p < 1) requestAnimationFrame(step); else el.textContent = target;
      };
      requestAnimationFrame(step);
    };
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        $$('[data-count]', e.target).forEach(el => reduce ? (el.textContent = el.dataset.count) : count(el));
        sio.unobserve(e.target);
      });
    }, { threshold: .35 });
    stats.forEach(s => sio.observe(s));
  }

  // 비포·애프터 슬라이더(11/2): range 입력(투명, 칸 전체)으로 손가락·마우스 모두 끌기
  $$('[data-ba]').forEach(box => {
    const range = $('input[type=range]', box);
    if (!range) return;
    const set = v => box.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => set(range.value));
    set(range.value);
  });

  // 우유 표면: 높이장 시뮬레이션 + WebGL 조명
  $$('.v2-milk').forEach(sec => {
    const cv = $('canvas', sec); if (!cv) return;
    const gl = cv.getContext('webgl2', { antialias: false, alpha: false, premultipliedAlpha: false });
    if (!gl) return;
    const CELL = 6;
    const touch = window.matchMedia('(hover: none)').matches;   // 커서 없는 기기(폰·태블릿)
    let W = 0, H = 0, cur, prev, tmp, running = false, lastX = -1, lastY = -1, lastT = 0, idle = 0, demoDone = false;
    const vs = `#version 300 es
      in vec2 p; out vec2 uv; void main(){ uv = p * .5 + .5; uv.y = 1. - uv.y; gl_Position = vec4(p, 0., 1.); }`;
    const fs = `#version 300 es
      precision highp float; in vec2 uv; out vec4 o;
      uniform sampler2D hmap; uniform vec2 grid; uniform float amp; uniform float t;
      float hAt(ivec2 c){ c = clamp(c, ivec2(0), ivec2(grid) - 1); return texelFetch(hmap, c, 0).r; }
      // 마우스가 없어도 아주 약하게 이는 너울: 긴 파장의 사인 두 겹이 천천히(주기 11~19초) 흘러감
      float amb(vec2 u){ vec2 g = u * grid;
        return 1.2 * sin(g.x * .045 + g.y * .02 + t * .55) * sin(g.y * .05 - g.x * .015 - t * .4)
             + .8 * sin(g.x * .03 - g.y * .04 + t * .33)
             + .55 * sin(g.x * .11 + g.y * .07 - t * .7) * sin(g.y * .09 - g.x * .04 + t * .5)
             + .4 * sin(g.x * .08 - g.y * .12 + t * .62); }
      float h(vec2 u){ vec2 g = u * grid - .5; vec2 f = fract(g); ivec2 c = ivec2(floor(g));
        float a = hAt(c), b = hAt(c + ivec2(1,0)), d = hAt(c + ivec2(0,1)), e = hAt(c + ivec2(1,1));
        return mix(mix(a, b, f.x), mix(d, e, f.x), f.y) + amb(u); }
      void main(){
        vec2 e = 1. / grid;
        float hx = h(uv + vec2(e.x, 0.)) - h(uv - vec2(e.x, 0.));
        float hy = h(uv + vec2(0., e.y)) - h(uv - vec2(0., e.y));
        vec3 n = normalize(vec3(-hx * amp, -hy * amp, 1.));
        vec3 L = normalize(vec3(-.45, -.6, .66)); vec3 V = vec3(0., 0., 1.);
        float diff = dot(n, L);
        float spec = pow(max(dot(n, normalize(L + V)), 0.), 48.);
        vec3 base = vec3(.957, .945, .922); vec3 shade = vec3(.87, .845, .80);
        float dd = diff - .66; dd = dd > 0. ? dd * .25 : dd * .6;
        vec3 col = base + dd * (base - shade) + spec * .03;
        col = min(col, base + .018);
        vec2 q = (uv - .5) * vec2(1., 1.35);
        col *= 1. - .045 * smoothstep(.45, 1.1, length(q));
        col = min(col, base + .018);
        o = vec4(col, 1.);
      }`;
    const sh = (t, s) => { const x = gl.createShader(t); gl.shaderSource(x, s); gl.compileShader(x); return x; };
    const prog = gl.createProgram(); gl.attachShader(prog, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(prog); gl.useProgram(prog);
    const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    const uGrid = gl.getUniformLocation(prog, 'grid'), uAmp = gl.getUniformLocation(prog, 'amp'), uT = gl.getUniformLocation(prog, 't');
    const size = () => {
      const dpr = Math.min(1.5, window.devicePixelRatio || 1);
      cv.width = Math.round(sec.clientWidth * dpr); cv.height = Math.round(sec.clientHeight * dpr);
      gl.viewport(0, 0, cv.width, cv.height);
      W = Math.ceil(sec.clientWidth / CELL); H = Math.ceil(sec.clientHeight / CELL);
      cur = new Float32Array(W * H); prev = new Float32Array(W * H); tmp = new Float32Array(W * H);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.R32F, W, H, 0, gl.RED, gl.FLOAT, cur);
      gl.uniform2f(uGrid, W, H); gl.uniform1f(uAmp, 1.0);
    };
    size(); window.addEventListener('resize', size);
    const drop = (x, y, r, s) => {
      const cx = Math.round(x / CELL), cy = Math.round(y / CELL);
      for (let j = -r; j <= r; j++) for (let i = -r; i <= r; i++) {
        const d = Math.sqrt(i * i + j * j); if (d > r) continue;
        const X = cx + i, Y = cy + j; if (X < 1 || Y < 1 || X >= W - 1 || Y >= H - 1) continue;
        const k = 1 - d / r; prev[Y * W + X] += s * k * k * (3 - 2 * k);
      }
    };
    sec.addEventListener('pointermove', e => {
      const b = sec.getBoundingClientRect(), x = e.clientX - b.left, y = e.clientY - b.top, now = performance.now();
      idle = 0;
      if (lastX >= 0) {
        const dist = Math.hypot(x - lastX, y - lastY);
        if (dist < 14 && now - lastT < 60) return;
        const n = Math.max(1, Math.min(8, Math.ceil(dist / 16)));
        const s = 0.32 + Math.min(0.35, dist / (now - lastT + 1) * 0.22);
        for (let k = 1; k <= n; k++) drop(lastX + (x - lastX) * k / n, lastY + (y - lastY) * k / n, 9, s);
      } else drop(x, y, 10, 0.6);
      lastX = x; lastY = y; lastT = now;
    });
    sec.addEventListener('pointerleave', () => { lastX = lastY = -1; });
    sec.addEventListener('pointerdown', e => { if (e.target.closest('a,button')) return; sec.classList.add('is-touched'); const b = sec.getBoundingClientRect(); drop(e.clientX - b.left, e.clientY - b.top, 14, 1.8); });
    // 터치 기기: 섹션이 보이면 손가락으로 한 번 쓸어낸 듯한 줄기를 자동으로 보여줌
    let demoTimer;
    const stroke = () => {
      const w = sec.clientWidth, h = sec.clientHeight, dir = Math.random() < .5 ? 1 : -1, y0 = 0.3 + Math.random() * 0.4;
      const pts = []; for (let k = 0; k <= 40; k++) { const t = k / 40; const x = dir > 0 ? 0.1 + t * 0.8 : 0.9 - t * 0.8; pts.push([w * x, h * (y0 + Math.sin(t * Math.PI * 1.5) * 0.12)]); }
      let k = 0; const step = () => { if (k >= pts.length) return; drop(pts[k][0], pts[k][1], 9, 0.6); k++; setTimeout(step, 28); };
      step();
    };
    const demo = () => {                     // 터치 기기: 보일 때 한 번, 이후 7초마다 반복
      if (demoDone) return; demoDone = true;
      setTimeout(stroke, 500);
      demoTimer = setInterval(() => { if (running) stroke(); }, 7000);
    };
    let acc = 0; const SPEED = 0.75;
    const idleGap = touch ? 100 : 110, idleRand = touch ? 90 : 100;
    // 섹션이 처음 충분히 보이면 바로 방울 두 개 → 움직이는 표면임을 일찍 알아차리게
    let greeted = false;
    const greet = () => {
      if (greeted) return; greeted = true;
      const w = sec.clientWidth, h = sec.clientHeight;
      setTimeout(() => drop(w * (0.55 + Math.random() * 0.3), h * (0.3 + Math.random() * 0.4), 12, 1.6), 350);
      setTimeout(() => drop(w * (0.25 + Math.random() * 0.3), h * (0.45 + Math.random() * 0.35), 10, 1.3), 1500);
    };
    const frame = () => {
      if (!running) return;
      idle++; if (idle > idleGap + Math.random() * idleRand) { drop(Math.random() * sec.clientWidth, Math.random() * sec.clientHeight, 10, 1.4); idle = 0; }
      acc += SPEED; if (acc < 1) { requestAnimationFrame(frame); return; } acc -= 1;
      for (let y = 1; y < H - 1; y++) { const r = y * W; for (let x = 1; x < W - 1; x++) { const i = r + x; tmp[i] = ((prev[i - 1] + prev[i + 1] + prev[i - W] + prev[i + W]) * 0.5 - cur[i]) * 0.976; } }
      for (let y = 1; y < H - 1; y++) { const r = y * W; for (let x = 1; x < W - 1; x++) { const i = r + x; cur[i] = tmp[i] * 0.6 + (tmp[i - 1] + tmp[i + 1] + tmp[i - W] + tmp[i + W]) * 0.1; } }
      gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, W, H, gl.RED, gl.FLOAT, cur);
      gl.uniform1f(uT, performance.now() / 1000);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      const t = prev; prev = cur; cur = t;
      requestAnimationFrame(frame);
    };
    new IntersectionObserver(([e]) => {
      const was = running; running = e.isIntersecting;
      if (running && !was) frame();
      if (running && e.intersectionRatio > 0.4) { if (touch) demo(); else greet(); }
    }, { threshold: [0, 0.45] }).observe(sec);
  });

  // 목장 사진 띠: 가로 스크롤(휴대폰 스와이프) + PC 마우스 드래그 + 화살표 (11/2)
  $$('.v2-album').forEach(row => {
    const step = () => { const f = row.firstElementChild; return f ? f.getBoundingClientRect().width + parseFloat(getComputedStyle(row).gap || 20) : row.clientWidth * .5; };
    const sec = row.closest('section') || document;
    $$('[data-album-dir]', sec).forEach(b => b.addEventListener('click', () => row.scrollBy({ left: step() * +b.dataset.albumDir, behavior: 'smooth' })));
    let down = false, sx = 0, sl = 0, moved = false;
    row.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = row.scrollLeft; row.classList.add('is-drag'); });
    window.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; row.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', () => { if (!down) return; down = false; row.classList.remove('is-drag'); });
    row.addEventListener('click', e => { if (moved) e.preventDefault(); }, true);
  });

  // 원료 라벨 트래킹(DKMEX 다섯 원료 영상): JSON의 프레임별 정규화 좌표를 영상 시간에 맞춰 라벨·선으로 표시 (11/2)
  $$('.v2-track[data-track]').forEach(async box => {
    const frame = box.parentElement, vid = $('video', frame); if (!vid) return;
    let data; try { data = await (await fetch(box.dataset.track)).json(); } catch (e) { return; }
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg'); box.appendChild(svg);
    const small = window.matchMedia('(max-width: 860px)');   // 휴대폰: 영상이 4:5로 잘려 라벨이 밖으로 나감 → 번호 점 + 영상 아래 범례
    const els = data.items.map((it, k) => {
      const line = document.createElementNS(NS, 'line'); svg.appendChild(line);
      const dot = document.createElementNS(NS, 'circle'); dot.setAttribute('r', 3.5); svg.appendChild(dot);
      const num = document.createElementNS(NS, 'text'); num.textContent = String(k + 1).padStart(2, '0'); num.setAttribute('text-anchor', 'middle'); num.setAttribute('class', 'v2-track__num'); svg.appendChild(num);
      const lab = document.createElement('div'); lab.className = 'v2-track__lab' + (it.dir === 'left' ? ' is-left' : ''); lab.textContent = it.label; box.appendChild(lab);
      return { it, line, dot, num, lab };
    });
    const legend = document.createElement('ol'); legend.className = 'v2-track__legend v2-wrap';
    legend.innerHTML = data.items.map((it, k) => '<li><b>' + String(k + 1).padStart(2, '0') + '</b>' + it.label + '</li>').join('');
    frame.insertAdjacentElement('afterend', legend);
    const GAP = 3.5, LEN = 64;   // 선은 점 가장자리에서 바로 시작, 선 길이
    const draw = () => {
      const W = frame.clientWidth, H = frame.clientHeight; if (!W || !H) return;
      const sc = Math.max(W / data.w, H / data.h), vw = data.w * sc, vh = data.h * sc, ox = (W - vw) / 2, oy = (H - vh) / 2;   // object-fit: cover 와 같은 계산
      const i = Math.min(data.n - 1, Math.max(0, Math.round(vid.currentTime * data.fps)));
      const m = small.matches; box.classList.toggle('is-small', m);
      els.forEach(({ it, line, dot, num, lab }) => {
        const p = it.pts[i]; const x = ox + p[0] * vw, y = oy + p[1] * vh;
        const dir = it.dir === 'left' ? -1 : 1;
        dot.setAttribute('cx', x); dot.setAttribute('cy', y);
        if (m) {
          dot.setAttribute('r', 10); num.setAttribute('x', x); num.setAttribute('y', y + 3.5);
        } else {
          dot.setAttribute('r', 3.5);
          const x1 = x + dir * GAP, x2 = x + dir * (GAP + LEN);
          line.setAttribute('x1', x1); line.setAttribute('y1', y); line.setAttribute('x2', x2); line.setAttribute('y2', y);
          lab.style.left = (x2 + dir * 6) + 'px'; lab.style.top = y + 'px';
        }
      });
    };
    let raf = 0; const loop = () => { draw(); raf = requestAnimationFrame(loop); };
    const start = () => { if (!raf) loop(); box.classList.add('is-on'); };
    const stop = () => { cancelAnimationFrame(raf); raf = 0; };
    vid.addEventListener('playing', start); vid.addEventListener('pause', stop); vid.addEventListener('ended', stop);
    window.addEventListener('resize', draw);
    if (!vid.paused && vid.readyState >= 2) start(); else draw();
  });

  // DKMEX 원료 구슬: 세로 2단(위 색/아래 알파) mp4를 WebGL로 합성해 투명 영상처럼 재생. 안 되면 포스터 그림 그대로 (10/29)
  const sph = $('#v2Sphere');
  if (sph) {   // 움직임 줄이기 설정은 따로 보지 않음(배너 영상·우유 표면과 동일 기준)
    const cv = $('canvas', sph);
    const gl = cv && cv.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false });   // 미리 곱한 알파(기본값): 일부 브라우저가 straight 알파를 무시해 투명 부분이 흰 네모로 보였음
    if (gl) {
      const vid = document.createElement('video');
      vid.muted = true; vid.loop = true; vid.playsInline = true; vid.preload = 'auto';
      vid.setAttribute('muted', ''); vid.setAttribute('playsinline', ''); vid.setAttribute('loop', '');
      sph.appendChild(vid);
      const sh = (t, s) => { const x = gl.createShader(t); gl.shaderSource(x, s); gl.compileShader(x); return x; };
      const prog = gl.createProgram();
      gl.attachShader(prog, sh(gl.VERTEX_SHADER, 'attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}'));
      gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, 'precision mediump float;varying vec2 v;uniform sampler2D t;void main(){vec3 c=texture2D(t,vec2(v.x,v.y*.5)).rgb;float a=texture2D(t,vec2(v.x,.5+v.y*.5)).r;gl_FragColor=vec4(c*a,a);}'));
      gl.linkProgram(prog); gl.useProgram(prog);
      const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      const tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      const size = () => { const dpr = Math.min(2, window.devicePixelRatio || 1); cv.width = Math.round(sph.clientWidth * dpr); cv.height = Math.round(sph.clientHeight * dpr); gl.viewport(0, 0, cv.width, cv.height); };
      size(); window.addEventListener('resize', size);
      let running = false, live = false;
      const draw = () => {
        if (!running) return;
        if (vid.readyState >= 2 && !vid.paused) {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, vid);
          gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
          if (!live) { live = true; sph.classList.add('is-live'); }
        }
        requestAnimationFrame(draw);
      };
      new IntersectionObserver(([e]) => {
        const was = running; running = e.isIntersecting;
        if (running) { if (!vid.src) vid.src = sph.dataset.src; vid.play().catch(() => {}); if (!was) draw(); }
        else vid.pause();
      }, { rootMargin: '300px 0px' }).observe(sph);
    }
  }
})();
